export function qbMatchScore(qbCustomer, crmClient) {
  let score = 0;
  const qbEmail = (qbCustomer.email || "").toLowerCase();
  const crmEmail = (crmClient.email || "").toLowerCase();
  const qbName = (qbCustomer.displayName || qbCustomer.companyName || "").toLowerCase();
  const crmName = (crmClient.name || "").toLowerCase();
  const qbPhone = (qbCustomer.phone || "").replace(/\D/g, "");
  const crmPhone = (crmClient.phone || "").replace(/\D/g, "");
  if (qbEmail && crmEmail && qbEmail === crmEmail) score += 100;
  if (qbPhone && crmPhone && qbPhone.length >= 7 && qbPhone === crmPhone) score += 60;
  const sim = (a, b) => {
    if (!a || !b) return 0;
    if (a === b) return 50;
    const aw = a.split(/\s+/); const bw = b.split(/\s+/);
    const common = aw.filter(w => w.length > 2 && bw.some(bv => bv.includes(w) || w.includes(bv)));
    return common.length > 0 ? Math.min(40, common.length * 20) : 0;
  };
  score += sim(qbName, crmName);
  if (crmClient.spouseName) score += sim(qbName, (crmClient.spouseName || "").toLowerCase()) * 0.5;
  (crmClient.businesses || []).forEach(biz => { score += sim(qbName, (biz.legalName || "").toLowerCase()) * 0.8; });
  return Math.round(score);
}

